const validacaoBootstrap = (form): boolean => {
  let hasBlankRequiredSelect = 0;

  // Buscar apenas elementos .input-select que pertencem ao formulário específico
  const formInputSelects = form.querySelectorAll(".input-select");

  formInputSelects.forEach((element) => {
    const dropdownToggle = element.querySelector(
      ".dropdown-toggle"
    ) as HTMLElement | null;
    if (!dropdownToggle) {
      return;
    }

    const style = window.getComputedStyle(element);
    const isHidden =
      style.display === "none" ||
      style.visibility === "hidden" ||
      element.closest(".modal") ||
      element.closest("[hidden]");

    if (isHidden) {
      return;
    }

    const label = element.querySelector("label") as HTMLElement | null;
    const isRequired = label?.classList.contains("required") ?? false;
    const selectedText = dropdownToggle.textContent?.trim() || "";
    const isPlaceholder = dropdownToggle.querySelector(".placeholder") !== null;
    const hasValue = selectedText !== "" && !isPlaceholder;

    if (isRequired && !hasValue) {
      dropdownToggle.style.border = "1px solid red";
      hasBlankRequiredSelect++;
      return;
    }
    dropdownToggle.style.border = "1px solid green";
  });

  form.classList.add("was-validated");

  if (form.checkValidity() && hasBlankRequiredSelect == 0) {
    return true;
  }

  form.reportValidity();
  return false;
};

const validacaoBootstrapParcial = (obj): boolean => {
  let aux = true;
  try {
    obj.classList.add("was-validated");
    const inputs = obj.getElementsByTagName("input");
    const selects = obj.getElementsByTagName("select");
    Array.prototype.forEach.call([inputs, selects], (elementos) => {
      Array.prototype.forEach.call(elementos, (element) => {
        if (!element.checkValidity()) {
          aux = false;
        }
      });
    });
  } catch (error) {
    aux = false;
  }
  return aux;
};

export { validacaoBootstrap, validacaoBootstrapParcial };
